import React from "react";
import MisAutorizacionesComponent from "../../../components/hb/mis-autorizaciones";

const MisAutorizaciones = () => {
  return (
    <div className="d-flex help-page">
      <MisAutorizacionesComponent />
    </div>
  );
};

export default MisAutorizaciones;
